module.exports = __webpack_public_path__ + "static/img/调查问卷-紫色@2x.2d5a68e.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/newYear/调查问卷-紫色@2x.png
// module id = O/ng
// module chunks = 87